import { render, staticRenderFns } from "./ManageUnused.vue?vue&type=template&id=c6aa6b1a&scoped=true"
import script from "./ManageUnused.vue?vue&type=script&lang=js"
export * from "./ManageUnused.vue?vue&type=script&lang=js"
import style0 from "./ManageUnused.vue?vue&type=style&index=0&id=c6aa6b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aa6b1a",
  null
  
)

export default component.exports